<template>
  <Page class="DistributorsPage">
    <IllustrationBanner />

    <div class="container">
      <h2 class="color--primary">{{ $t('distributorsPageHeading') }}</h2>
      <DistributorList :distributors="distributors" />
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page.vue';
import IllustrationBanner from '@/components/IllustrationBanner.vue';
import DistributorList from '@/components/distributor/List.vue';

export default {
  name: 'DistributorsPage',
  components: {
    Page,
    IllustrationBanner,
    DistributorList,
  },
  computed: {
    distributors() {
      return this.$store.state.filter.distributors;
    },
  },
};
</script>
